<template>
  <div class="home">
    <ui-title icon="account_balance">Home</ui-title>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis dolores numquam, facilis temporibus natus itaque, voluptatum aspernatur aut ducimus cupiditate recusandae odio doloremque expedita vel in debitis saepe repudiandae. Enim.</p>
  </div>
</template>

<script>
export default {
  name: 'home',
  title: 'Dashboard'
}
</script>



// WEBPACK FOOTER //
// Home.vue?5b5218cf